/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Link } from 'react-router';

import Uri from 'jsuri';

import path from 'js/lib/path';

import { IconButton, NotificationBadge } from '@coursera/cds-core';
import { CartIcon } from '@coursera/cds-icons';

import { useShoppingCart } from 'bundles/composable-page-header-consumer/contexts/ShoppingCartContext';
import IconButtonWrapper from 'bundles/composable-page-header/components/IconButtonWrapper';
import { DEFAULT_ICON_BUTTON_HEIGHT, DEFAULT_ICON_BUTTON_SVG_HEIGHT } from 'bundles/composable-page-header/constants';
import constants from 'bundles/payments-common/common/constants';
import savedCartUtils from 'bundles/payments-common/lib/savedCartUtils';

import _t from 'i18n!nls/composable-page-header-consumer';

const styles = {
  badge: css`
    > .cds-notificationBadge-top {
      position: relative;
      left: -5px;
      top: 2px;
    }
  `,
};

const getCartPageUrl = () => {
  const cartInfo = savedCartUtils.get();
  const cartId = cartInfo && cartInfo.id;

  if (cartId) {
    return new Uri()
      .setPath(path.join(constants.rootPath, constants.cartUrl))
      .addQueryParam('cartId', cartId.toString())
      .toString();
  } else {
    return '/';
  }
};

const ShoppingCartGridItem = () => {
  const shoppingCart = useShoppingCart();
  const cartPageUrl = React.useMemo(() => getCartPageUrl(), []);
  const ariaText = _t('View your shopping cart');

  React.useEffect(() => {
    if (!shoppingCart?.loading && !shoppingCart?.isValidCart) {
      savedCartUtils.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!shoppingCart?.isValidCart) {
    return null;
  }

  return (
    <NotificationBadge align="top" value={1} css={styles.badge}>
      <IconButtonWrapper
        iconButton={
          <IconButton
            tooltip={ariaText}
            aria-label={ariaText}
            href={cartPageUrl}
            size="small"
            variant="ghost"
            icon={<CartIcon size="large" color="support" />}
            component={Link}
          />
        }
        buttonSize={DEFAULT_ICON_BUTTON_HEIGHT}
        svgSize={DEFAULT_ICON_BUTTON_SVG_HEIGHT}
      />
    </NotificationBadge>
  );
};

export default ShoppingCartGridItem;
